<template>
    <div class="trend">
        <div class="title">场次趋势</div>
        <div class="trendBox">
            <div id="trend" class="fl" :style="`width: 30vw; height: 370px;`"></div>
            <div class="footBtn clear">
                <span class="fl" :class="{'xz': xzIndex == 0}" @click="changeTime(0)">最近30天</span>
                <span class="fl" :class="{'xz': xzIndex == 1}" @click="changeTime(1)">最近7天</span>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import bigData from '@/services/bigData'
export default {
    data() {
        return {
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: [{
                    type: 'category',
                    show: false,
                    data: [],
                    axisTick: {
                        inside: true,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#3D3D65',
                            type: 'solid'
                        }
                    },
                }],
                yAxis: [{
                    type: 'value',
                    splitNumber: 4,
                    minInterval: 1,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(61, 61, 101, 0.9)'
                        }
                    },
                    axisLabel: {
                        show: true,
                        color: '#e2e9ff',
                        textStyle: {
                            fontSize: 12,
                            color: '#8585CF'
                        },
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#3D3D65',
                            type: 'solid'
                        }
                    },
                    axisTick: {
                        inside: true,
                    },
                    splitArea: {
                        show: false
                    }
                }],
                series: [{
                    name: '场次',
                    type: 'line',
                    data: [],
                    itemStyle: {
                        normal: {
                            color: '#fff',
                            borderWidth: 1,
                        }
                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(88, 84, 255, 0.9)'
                                }, {
                                    offset: 0.5,
                                    color: 'rgba(88, 84, 255, 0.7)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(88, 84, 255, 0)'
                                }
                            ], false),
                            shadowColor: 'rgba(0,179,244, 0.9)',
                            shadowBlur: 20
                        }
                    },
                    smooth: true
                }]
            },
            xzIndex: 0,
        }
    },
    mounted() {
        this.changeTime(this.xzIndex)
    },
    methods: {
        getData(data) {
            this.option.xAxis[0].data = []
            this.option.series[0].data = []
            bigData.dynamic(data).then(res => {
                res.result.map(v => {
                    this.option.xAxis[0].data.push(v.day)
                    this.option.series[0].data.push(v.total)
                })
                this.set()
            })
        },
        set(){
            this.myChart = echarts.init(document.getElementById('trend'));
            this.myChart.clear();//如果图表有修改需求建议加上此方法先清后画
            this.myChart.setOption(this.option);
        },
        changeTime(num) {
            this.xzIndex = num;
            this.getData(num == 1 ? 7 : 30)
        },
    }
}
</script>

<style lang="scss" scoped>
.trend{
    width: 30vw;
    .title{
        margin-top: 24px;
        color: #fff;
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 16px;
    }
}
#level{
    width: 30vw;
    height: 370px;
    background-color: #292941;
}
.trendBox{
    background-color: rgba(41, 41, 65, 1);
    border-radius: 12px;
    padding-bottom: 18px;
}
.footBtn{
    background-color: #24243A;
    width: 176px;
    margin: 0 auto;
    border-radius: 6px;
    overflow: hidden;
    font-size: 14px;
    line-height: 36px;
    span{
        width: 50%;
        color: #A1A1CC;
        text-align: center;
        cursor: pointer;
    }
    span.xz{
        background-color: #4D4D7D;
        color: #fff;
        border-radius: 6px;
    }
}
</style>
